var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagTr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6H3V18H21V6Z",
    fill: "#E30A17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 15.0002C11.0319 15.0002 12.375 13.6571 12.375 12.0002C12.375 10.3434 11.0319 9.00024 9.375 9.00024C7.71815 9.00024 6.375 10.3434 6.375 12.0002C6.375 13.6571 7.71815 15.0002 9.375 15.0002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1251 14.4001C11.4506 14.4001 12.5251 13.3256 12.5251 12.0001C12.5251 10.6746 11.4506 9.6001 10.1251 9.6001C8.79961 9.6001 7.7251 10.6746 7.7251 12.0001C7.7251 13.3256 8.79961 14.4001 10.1251 14.4001Z",
    fill: "#E30A17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7498 12.0003L14.4636 12.8817L12.7866 10.5735V13.4271L14.4636 11.1189L11.7498 12.0003Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTr);
export default __webpack_public_path__ + "static/media/flag-tr.3ca6a108d1c5e116f55211cfd9040e86.svg";
export { ForwardRef as ReactComponent };